import {ResourceHelperService} from "../resource-helper.service";

/**
 * A dataservice that provides CRUD operations on the Fulfilment Requests backend resources
 */
export class FulfilmentRequestsService {
  private fulfilmentRequestResource: InterACT.Interfaces.IResource<any>;
  private fulfilmentRequestsResource: InterACT.Interfaces.IResource<any>;
  private fulfilmentRequestCancellationRequestResource: InterACT.Interfaces.IResource<any>;
  private fulfilmentRequestsSummaryResource: InterACT.Interfaces.IResource<any>;

  constructor(
    private $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService) {
    this.fulfilmentRequestResource = this.$resource('api/fulfilment-requests/:externalId', undefined);
    this.fulfilmentRequestsResource = this.$resource('api/fulfilment-requests/', undefined);
    this.fulfilmentRequestCancellationRequestResource = this.$resource('api/fulfilment-requests/:originalExternalId/cancellation-requests', undefined);
    this.fulfilmentRequestsSummaryResource = this.$resource('api/fulfilment-requests/summary', undefined);
  }

  /**
   * Function to retrieve a Fulfilment Requests summary object
   *
   * @param groupingQuery The group by query
   * @param query A query string to sort results by
   * @returns A http promise
   */
  public getFulfilmentRequestSummary(groupingQuery?: string, query?: string) {
    const options = this.resourceHelperService.buildSummaryRequestOptions(groupingQuery, query);

    return this.fulfilmentRequestsSummaryResource.get(options).$promise;
  }

  /**
   * Function to retrieve a Fulfilment Request
   *
   * @param externalId the externalId of the Fulfilment Request to retrieve
   *
   * @returns an http promise
   */
  public getFulfilmentRequest(externalId: string) {
    return this.fulfilmentRequestResource.get({externalId: externalId}).$promise;
  }

  /**
   * Function to retrieve a list of fulfilment requests filtered by status
   *
   * @param page the page to get fulfilment requests for
   * @param perPageCount the number of fulfilment requests per page
   * @param query A query string to sort results by
   *
   * @returns A http promise
   */
  public getFulfilmentRequests(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);

    return this.fulfilmentRequestsResource.get(options).$promise;
  }

  /**
   * Function to fire off a fulfilment cancellation request
   *
   * @param fulfilmentRequest the fulfilmentRequest to create a cancellation request for
   * @returns a http promise
   */
  public cancelFulfilmentRequest(fulfilmentRequest: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest) {
    return this.fulfilmentRequestCancellationRequestResource.save({originalExternalId: fulfilmentRequest.externalId}, {}).$promise;
  }

  /**
   * This function is used to get the state of a fulfilment request
   *
   * @param fulfilmentRequest the fulfilment request
   */
  public getFulfilmentRequestState = (fulfilmentRequest: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest) => {
    let state = fulfilmentRequest.state.name.split("_")[1];

    if (state != "REJECTED") {
      return state;
    } else {
      let timeoutReasonCodes = ['2012', '2014', '2016', '2019'];
      let reasonCode = fulfilmentRequest.state.reason.substr(0, 4);
      return timeoutReasonCodes.indexOf(reasonCode) >= 0 ? 'WINDOW TIMEOUT' : 'REJECTED';
    }
  }
}
